import hatsApi from '@/services/hatsApi'

export default {
  getCountries (params) {
    let filter = params || ''
    return hatsApi().get('/system/country/?filter=' + filter)
  },
  getCountry (id) {
    return hatsApi().get('/system/country/' + id)
  },
  saveCountry (data) {
    return hatsApi().put('/system/country/' + data.id, data)
  },
  getContinents (params) {
    let filter = params || ''
    return hatsApi().get('/system/continent/?filter=' + filter)
  },
  getCities (params) {
    let filter = params || ''
    return hatsApi().get('/master-data/city/?filter=' + filter)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Geo.js